export default __webpack_public_path__ + "static/media/lady-on-stool.fcfa5c57.jpg";